export const isNumber = value => {
    return /^-?\d+$/.test(value);
}

export const isValidUrl = str => {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

export const isValidText = str => {
    const txt = str.split(' ').join('')
    var containsLetters = /[a-zA-Z]/g.test(txt);
    let containsOnlyNumbers = /^\d+$/.test(txt);
    return !containsOnlyNumbers && containsLetters
}